'use strict';
exports.__esModule = true;
var angular = require("angular");
var tree_node_1 = require("../logic/tree-node");
var tree_logic_1 = require("../logic/tree-logic");
var tree_clipboard_1 = require("../logic/tree-clipboard");
var change_log_1 = require("../logic/change-log");
var broadcast_config_1 = require("../../../../report-options2/broadcast-config");
var project_category_assignment_logic_1 = require("../../../../../action/project-category-assignment/project-category-assignment.logic");
var filter_logic_1 = require("../../../../report-options2/filter-logic");
var tree_filter_1 = require("../logic/tree-filter");
var TreeNode = tree_node_1["default"].TreeNode;
angular.module("smartorg.r6.navs.tree").filter('byNodeType', function () {
    return function (changes, filterNodeType) {
        if (changes) {
            return changes.filter(function (item) {
                return (item.platform && filterNodeType.platform) ||
                    (item.leaf && filterNodeType.leaf) ||
                    (item.parent && filterNodeType.parent);
            });
        }
        else {
            return [];
        }
    };
});
angular.module("smartorg.r6.navs.tree").directive("tree", ["shareLink", "$rootScope", '$timeout', 'terminologyService', function (shareLink, $rootScope, $timeout, terminologyService) {
        return {
            restrict: "E",
            template: require("../../template/tree.html"),
            transclude: true,
            scope: {
                /**
                 * Holds everything related to the tree object.
                 */
                treeObj: "=",
                /**
                 * This variable stores the current tree loading status.
                 * value 1 means tree is loading or processing. 2 means
                 * process finished. Show spinner when value = 1.
                 */
                treeLoaded: "=",
                /**
                 * The API with credential info.
                 */
                astro: "=",
                /**
                 * In order to remove selected when change to another
                 * portfolio.
                 */
                selected: "=",
                /**
                 * Control search match count display.
                 */
                searching: "=",
                // True, when archived nodes should not be loaded
                lazyArchive: "=",
                enableSecondarySelect: '=',
                secondarySelected: '=',
                /**
                 /**
                 * When selecting tree node interferes the outside world.
                 */
                onSelectNode: "&?",
                getSubtree: "&?",
                /**
                 * Display message to user.
                 *
                 * Example:
                 scope.showAlert({
                     "type": "",
                     "title": "",
                     "message": ""
                    });
                 *
                 * Type can be; "success", "info", "warning", "danger".
                 */
                showAlert: "&?",
                // For any non-sys-admin to access restrict templates
                userPortfolioAccess: '<?',
                /**
                 * Terminology for dynamic text based on product type
                 */
                terminology: '=?'
            },
            link: function (scope) {
                scope.userIsSysAdmin = false;
                scope.userIsPortfolioAdmin = false;
                scope.actionType = "none";
                scope.searchEnabled = true;
                scope.selected = undefined;
                scope.selectedTemplates = [];
                scope.platformOrLeaf = "leaf";
                scope.useSelectedNode = true;
                scope.filterLogic = undefined;
                scope.excludedFilterTags = [];
                scope.defaultCategories = [];
                scope.treeName = scope.treeObj && scope.treeObj.treeName ? scope.treeObj.treeName : "";
                // Initialize terminology with defaults if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                scope.$watch('treeLoaded', function (newValue, oldValue) {
                    scope.filterLogic = shareLink.getTreeFilters();
                    scope.excludedFilterTags = shareLink.getTreeExcludeFilters();
                    if (newValue == 2) {
                        $timeout(function () {
                            $('.lastUpdatedTooltip').popover({
                                placement: 'right',
                                trigger: 'hover'
                            }).on('mouseleave', function () {
                                var _this = this;
                                if (!$('.popover:hover').length) {
                                    $(_this).popover('hide');
                                    scope.$apply();
                                }
                            });
                        }, 500);
                    }
                });
                scope.$on('tree:showTreeColors', function (event, args) {
                    scope.showTreeColors = args.showTreeColors;
                });
                scope.collapseNode = function (treeNode) {
                    treeNode.expanded = false;
                };
                scope.expandNode = function (treeNode) {
                    treeNode.expanded = true;
                    if (treeNode._id && treeNode.childrenIds.length > 0 && (treeNode.children.length == 0 && !treeNode.loading) && scope.lazyArchive) {
                        treeNode.loading = true;
                        scope.getSubtree({ nodeId: treeNode._id, getNewChildren: false });
                    }
                    $timeout(function () {
                        $('.lastUpdatedTooltip').popover({
                            placement: 'right',
                            trigger: 'hover'
                        }).on('mouseleave', function () {
                            var _this = this;
                            if (!$('.popover:hover').length) {
                                $(_this).popover('hide');
                                scope.$apply();
                            }
                        });
                    }, 500);
                };
                var expandAllLevels = function (treeNode) {
                    if (scope.treeObj.fullTree) {
                        scope.expandNode(treeNode);
                        treeNode.children.forEach(function (child) {
                            expandAllLevels(child);
                        });
                    }
                    else {
                        alert(scope.terminology.Portfolio + " is still loading in the background. " +
                            "\nPlease try double-clicking after few seconds.");
                    }
                };
                scope.expandOrCollapseNode = function (treeNode) {
                    if (treeNode.childrenIds && treeNode.childrenIds.length > 0) {
                        treeNode.expanded ? scope.collapseNode(treeNode) : expandAllLevels(treeNode);
                    }
                };
                scope.$on(broadcast_config_1["default"].SET_DEFAULT_AND_TREE_FILTER, function (event, args) {
                    scope.defaultReportOptions = args.defaultReportOptions;
                    scope.defaultTreeViewFilters = args.defaultTreeViewFilters;
                    shareLink.setDefaultTreeFilters(args.defaultTreeViewFilters.filterLogic);
                    shareLink.setDefaultTreeExcludeFilters(args.defaultTreeViewFilters.excludedTags);
                });
                scope.$on("Tree:NodeSelected", function (event, args) {
                    scope.selected = args.selected;
                });
                scope.makeAllCategories = function () {
                    scope.allCategories = [];
                    if ('categoriesConfig' in scope.treeObj.treeData) {
                        var categoriesConfig = scope.treeObj.treeData['categoriesConfig'];
                        categoriesConfig.forEach(function (category) {
                            var categoryName = category.CategoryName;
                            category.CategoryEntries.forEach(function (entry) {
                                if (entry && entry != '') {
                                    var tag = categoryName + ':' + entry;
                                    scope.allCategories.push(tag);
                                }
                            });
                        });
                    }
                };
                /**
                 * Show search tool bar.
                 */
                scope.toggleSearch = function () {
                    scope.searchEnabled = !scope.searchEnabled;
                    // Not working without this set timeout.
                    // Seems something to do with angular.
                    setTimeout(function () {
                        $("#treeSearchTextbox").focus();
                    }, 0);
                };
                // =====================================================
                // When functions are not passed in
                // =====================================================
                if (!scope.onSelectNode) {
                    scope.onSelectNode = function () {
                        scope.showAlert({
                            "type": "warning",
                            "title": "Warning",
                            "message": "Select function not available."
                        });
                    };
                }
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        scope.alertType = input["type"];
                        scope.messageTitle = input["title"];
                        scope.messageBody = input["message"];
                        scope.$apply();
                    };
                }
                function showAlert(type, title, message) {
                    scope.showAlert({ type: type, title: title, message: message });
                }
                scope.addNodeModalShowAlert = function (showAlertDetails) {
                    var type = showAlertDetails.type, title = showAlertDetails.title, message = showAlertDetails.message;
                    scope.showAlert({ type: type, title: title, message: message });
                };
                // =====================================================
                // Search tree nodes by name
                // =====================================================
                /**
                 * Keyword for searching.
                 *
                 * @type {string}
                 */
                scope.searchKey = "";
                /**
                 * Last keyword for searching. If this one is equal to
                 * current one, use the high light node as start point.
                 * Otherwise use selected node.
                 *
                 * @type {string}
                 */
                scope.lastSearchKey = "";
                scope.searchTreeNode = function (direction) {
                    if (!scope.treeObj) {
                        return;
                    }
                    var startNode = scope.searchKey === scope.lastSearchKey ?
                        scope.searchStartNode : scope.selected;
                    scope.dehighlightAll();
                    if (!scope.searchKey) {
                        return;
                    }
                    var searchResult = scope.treeObj.searchNode(startNode, scope.searchKey, direction);
                    scope.lastSearchKey = scope.searchKey;
                    scope.searching = true;
                    if (searchResult) {
                        scope.searchResultIndex = searchResult.resultIndex;
                        scope.searchTotalMatches = searchResult.totalMatch;
                        scope.highlightSearchResults(searchResult.resultNodes);
                        scope.highlightNode(searchResult.resultNodes[searchResult.resultIndex - 1]);
                        scope.searchStartNode = searchResult.resultNodes[searchResult.resultIndex - 1];
                    }
                    else {
                        scope.searchResultIndex = 0;
                        scope.searchTotalMatches = 0;
                    }
                    $timeout();
                };
                /**
                 * Enter to trigger the search event.
                 */
                scope.searchEnterEvent = function (event) {
                    if (event.which === 13) {
                        if (scope.treeObj.isArchiveLoaded) {
                            scope.searchTreeNode(1);
                        }
                        else {
                            // Replace the showAlert with a modal dialog
                            bootbox.dialog({
                                message: 'Some nodes in the tree are being loaded in the background. Please wait for the entire tree to be loaded.',
                                title: 'Tree Loading',
                                buttons: {
                                    ok: {
                                        label: 'OK',
                                        className: 'btn-primary'
                                    }
                                }
                            });
                        }
                    }
                };
                /**
                 * Whenever a search keyword changed, clear current search.
                 */
                scope.clearSearching = function () {
                    scope.searching = false;
                    scope.searchResultIndex = 0;
                    scope.searchTotalMatches = 0;
                    scope.dehighlightAll();
                };
                scope.clearSearchKey = function () {
                    scope.searchKey = "";
                    scope.clearSearching();
                };
                scope.highlightSearchResults = function (nodes) {
                    for (var i = 0; i < nodes.length; i++) {
                        nodes[i].highlight = 1;
                        showSearchResultPath(nodes[i]);
                        showSearchResultChildren(nodes[i]);
                    }
                };
                var showSearchResultPath = function (node) {
                    if (node.parent) {
                        var parentNode = scope.treeObj.nodeMap[node.parent._id];
                        if (!('highlight' in parentNode) || parentNode.highlight == 0) {
                            parentNode.highlight = 3;
                        }
                        showSearchResultPath(parentNode);
                    }
                };
                var showSearchResultChildren = function (node) {
                    if (node.hasChildren) {
                        for (var i = 0; i < node.children.length; i++) {
                            var childNode = scope.treeObj.nodeMap[node.children[i]._id];
                            if (childNode.highlight == 0) {
                                childNode.highlight = 3;
                            }
                            showSearchResultChildren(childNode);
                        }
                    }
                };
                scope.highlightNode = function (node) {
                    node.highlight = 2;
                };
                scope.dehighlightAll = function () {
                    var node = scope.treeObj.treeData;
                    do {
                        node.highlight = 0;
                        node = node.next;
                    } while (node._id != scope.treeObj.treeData._id);
                };
                // =====================================================
                // Select node and template related
                // =====================================================
                scope.selectNode = function (treeNode) {
                    if ($rootScope.smartorgDirty) {
                        var discardChange = confirm("The unsaved data will be lost. Do you want to proceed?");
                        if (discardChange) {
                            $rootScope.smartorgDirty = false;
                        }
                        else {
                            return;
                        }
                    }
                    scope.selected = treeNode;
                    var platformNode = tree_logic_1["default"].JsonTree.ancestorIsPlatformInclude(scope.selected);
                    if (platformNode) {
                        scope.selected.platformNodeName = platformNode.name;
                    }
                    // Update query string. Clean up menu.
                    //
                    // Problem: If url changed manually, furthur change will
                    //     not be applied until refresh.
                    shareLink.setValue("treenode", scope.selected._id);
                    shareLink.clearValue("menu");
                    shareLink.clearValue("options");
                    // This function is in workbench, so keep it this way.
                    scope.onSelectNode({ nodeID: treeNode._id });
                };
                scope.rightClickNode = function (treeNode) {
                    scope.showTreeDropdowns = false;
                    if ($("ul").hasClass("treeEditMenuClass")) {
                        $(".treeEditMenuToggle").dropdown('toggle');
                    }
                    if ($("ul").hasClass("managementMenuClass")) {
                        $(".managementMenuToggle").dropdown('toggle');
                    }
                    if (treeNode._id !== (scope.selected ? scope.selected._id : null)) {
                        scope.selectNode(treeNode);
                    }
                };
                scope.closeContextMenu = function () {
                    if (scope.showTreeDropdowns == undefined) {
                        if (!($("ul").hasClass("managementMenuClass"))) {
                            $(".managementMenuToggle").dropdown('toggle');
                        }
                    }
                    scope.showTreeDropdowns = true;
                    document.getElementById("contextMenu").style.display = 'none';
                    if (!($("ul").hasClass("managementMenuClass"))) {
                        $(".managementMenuToggle").dropdown('toggle');
                    }
                };
                var reloadTemplate = function () {
                    scope.loadTemplate(scope.selected._id);
                };
                // =====================================================
                // The following functions are based on selected node.
                // =====================================================
                scope.initAdd = function () {
                    scope.actionType = "add";
                    reloadTemplate();
                };
                scope.initEdit = function () {
                    scope.actionType = "edit";
                    reloadTemplate();
                    scope.getNodeInfo(scope.selected._id);
                    scope.nodeName = scope.selected.name;
                };
                /**
                 * Save children order change.
                 */
                scope.saveChildren = function () {
                    var newOrderList = angular.element("#sortList").sortable("toArray");
                    var hasError = false;
                    var changed = false;
                    if (newOrderList && scope.selected.children) {
                        for (var i = 0; i < newOrderList.length; i++) {
                            if (!scope.selected.children[i]) {
                                hasError = true;
                                break;
                            }
                            else if (scope.selected.children[i]._id !=
                                newOrderList[i]) {
                                changed = true;
                                break;
                            }
                        }
                    }
                    else {
                        hasError = true;
                    }
                    if (hasError) {
                        scope.showAlert({
                            "type": "danger",
                            "title": "Server Error 404",
                            "message": "Failed to change node order."
                        });
                    }
                    else if (changed) {
                        scope.onEditNode({
                            'nodeId': scope.selected._id,
                            'newNodeName': scope.selected.name,
                            'templateName': '',
                            'children': angular.element("#sortList").sortable("toArray"),
                            'saveTags': []
                        });
                    }
                    else {
                        scope.showAlert({
                            "type": "info",
                            "title": "Not Saved",
                            "message": "Nothing has been changed, ending process."
                        });
                    }
                    $("#childrenRearrangeModal").modal("hide");
                };
                /**
                 * Download all inputs for selected subnode.
                 */
                scope.downloadInputs = function () {
                    var treeId = scope.treeObj.treeName;
                    var nodeId = scope.selected._id;
                    scope.astro.fetchInputData(treeId, nodeId).then(function (rs) {
                        if (rs.status === 0) {
                            var blob = new Blob([rs.data.report], { type: "text/plain;charset=utf-8" });
                            var filename = rs.data.nodeName + "." +
                                new Date().toISOString() + ".csv";
                            saveAs(blob, filename);
                        }
                    })["catch"](function (err) {
                        scope.showAlert({
                            "type": "danger",
                            "title": "Server Error " + err.status,
                            "message": err.message
                        });
                    });
                };
                scope.showArrangeModal = function () {
                    scope.arrangeChanged = false;
                    $("#childrenRearrangeModal").modal({ backdrop: 'static', keyboard: false, show: true });
                    scope.arrangeOriginal = scope.selected.children.map(function (item) { return item._id; });
                    scope.arrangeChanged = false;
                };
                /**
                 * Necessary for sorting nodes.
                 */
                $(function () {
                    angular.element("#sortList").sortable({
                        placeholder: "treeview-sort-placeholder",
                        stop: function (event, ui) {
                            var newOrderList = angular.element("#sortList").sortable("toArray");
                            scope.arrangeChanged = JSON.stringify(newOrderList) !== JSON.stringify(scope.arrangeOriginal);
                            setTimeout(function () {
                                scope.$apply();
                            }, 0);
                        }
                    });
                    // angular.element("#sortList").disableSelection();
                });
                // =====================================================
                // Cut and copy (without paste) do not need server side
                // response.
                // =====================================================
                /**
                 * Not used now, using copy/paste + delete to acheive cut.
                 */
                scope.cutNode = function () {
                    if (scope.selected.parent) {
                        scope.actionType = "cut";
                        tree_clipboard_1["default"].Clipboard.cut(scope.selected);
                    }
                    else {
                        showAlert('warning', 'Warning!', 'Cut operation cannot be performed in root node.');
                    }
                };
                /**
                 * Add a node to clipboard.
                 */
                scope.copyNode = function () {
                    scope.actionType = "copy";
                    tree_clipboard_1["default"].Clipboard.copy(scope.selected);
                };
                scope.pasteAsSubtree = function () {
                    var clipboardItem = tree_clipboard_1["default"].Clipboard.paste();
                    if (!clipboardItem) {
                        // alert("Please copy something before paste.");
                        showAlert('warning', 'Warning!', 'Please copy something before paste.');
                    }
                    else {
                        // Check if there is any platform confliction.
                        var nodeA = tree_logic_1["default"].JsonTree.nodeHasPlatformChildInclude(clipboardItem.item);
                        var nodeB = scope.selected.platformNodeName;
                        if (nodeA && nodeB) {
                            var msg = "Cannot paste platform node (" +
                                nodeA.name +
                                ") under platform (" +
                                nodeB + ")";
                            scope.showAlert({
                                "type": "danger",
                                "title": "Platform Error",
                                "message": msg
                            });
                        }
                        else {
                            if (clipboardItem.item.parentId == scope.selected._id && scope.actionType == 'cut') {
                                showAlert('warning', 'Warning!', 'Cut and paste cannot happen under same parent node.');
                            }
                            else {
                                scope.actionType = "paste";
                                var isPortfolio_1 = scope.selected.parent === undefined || scope.selected.parent === null || clipboardItem.item.parent === undefined; // If selected/operated node is root node 
                                var cutFromPortfolio_1 = scope.selected.parent === undefined || scope.selected.parent === null || (clipboardItem.item.path && clipboardItem.item.path.length === 1 && clipboardItem.type.toString() === "0"); // If cut node is first level child of root node, refresh needed 
                                if (isPortfolio_1) {
                                    bootbox.dialog({
                                        message: "Pasting into the " + scope.terminology.portfolio + " at root level will reload the entire " + scope.terminology.portfolio + ". You will lose the current filters unless they are set as default filters. Do you want to proceed pasting?",
                                        title: "Confirm Paste",
                                        buttons: {
                                            confirm: {
                                                label: "Yes",
                                                className: "btn-danger",
                                                callback: function () {
                                                    scope.onPasteNode(scope.selected._id, clipboardItem.item._id, clipboardItem.type.toString(), clipboardItem.item.parentId, isPortfolio_1);
                                                }
                                            },
                                            cancel: {
                                                label: "No",
                                                className: "btn-primary"
                                            }
                                        }
                                    });
                                }
                                else if (cutFromPortfolio_1) {
                                    bootbox.dialog({
                                        message: "Moving a node from the " + scope.terminology.portfolio + " at root level will reload the entire " + scope.terminology.portfolio + ". You will lose the current filters unless they are set as default filters. Do you want to proceed pasting?",
                                        title: "Confirm Paste",
                                        buttons: {
                                            confirm: {
                                                label: "Yes",
                                                className: "btn-danger",
                                                callback: function () {
                                                    scope.onPasteNode(scope.selected._id, clipboardItem.item._id, clipboardItem.type.toString(), clipboardItem.item.parentId, cutFromPortfolio_1);
                                                }
                                            },
                                            cancel: {
                                                label: "No",
                                                className: "btn-primary"
                                            }
                                        }
                                    });
                                }
                                else {
                                    scope.onPasteNode(scope.selected._id, clipboardItem.item._id, clipboardItem.type.toString(), clipboardItem.item.parentId, isPortfolio_1);
                                }
                            }
                        }
                    }
                };
                scope.openInputScreen = function (log) {
                    if (log.menuID === "AssignCategories") {
                        scope.triggerEmit('DisplayCategoryAssignment', log.inputKey);
                    }
                    else {
                        scope.$emit("workbench:redirect", {
                            treenode: log.nodeID,
                            menu: log.menuID
                        });
                    }
                    // scope.openIPScreen = true;
                    // console.log("Magically open node and input screen, then open changes dialog");
                };
                scope.fetchChangeLog = function (nodeID) {
                    scope.astro.changeLog(nodeID).then(function (changeLog) {
                        scope.changeLog = changeLog.sort(function (a, b) {
                            // Turn your strings into dates, and then subtract them
                            // to get a value that is either negative, positive, or zero.
                            return new Date(b.timestamp) - new Date(a.timestamp);
                        });
                        scope.changeLogLoading = false;
                        scope.$apply();
                    })["catch"](function (err) {
                        console.error(err);
                    });
                };
                scope.downloadChangeLog = function () {
                    var changeLog = new change_log_1["default"](scope.changeLog);
                    downloadCSV(changeLog.toCSV());
                };
                var downloadCSV = function (csv) {
                    var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
                    saveAs(blob, "ChangeLog_" + Common.getDate() + ".csv");
                };
                scope.showChangesDialog = function () {
                    scope.hasPlatform = false;
                    scope.filterNodeType = {
                        platform: true,
                        leaf: true,
                        parent: true
                    };
                    angular.element('#changesModal').modal({ backdrop: 'static', keyboard: false, show: true });
                    var nodeID = scope.selected === undefined ? scope.treeObj.treeData._id : scope.selected._id;
                    scope.changeLogLoading = true;
                    if (scope.selected === undefined) {
                        scope.hasPlatform = tree_logic_1["default"].JsonTree.nodeHasPlatformChild(scope.treeObj.treeData) !== undefined;
                    }
                    else {
                        scope.hasPlatform = scope.selected.isPlatform === true || tree_logic_1["default"].JsonTree.nodeHasPlatformChild(scope.selected) !== undefined;
                    }
                    scope.defaultEndPoint = scope.hasPlatform ? "platform" : "leaf";
                    this.fetchChangeLog(nodeID);
                };
                /**
                 * Recalculate tree modal
                 */
                scope.showRecalculateDialog = function () {
                    angular.element('#recalculateModal').modal({ backdrop: 'static', keyboard: false, show: true });
                };
                /**
                 * Make a node and its descendants read-only or editable.
                 * When a node is made read-only, all its input commands should
                 * be non-editable.
                 * When a node is made editable, all its input commands should
                 * be editable.
                 */
                scope.readonly = function () {
                    scope.readonlyPermission = angular.copy(scope.selected.permissions);
                    if (scope.readonlyPermission !== 'r') {
                        scope.readonlyPermission = '';
                    }
                    scope.includeAllChildren = true;
                    angular.element('#makeReadonlyModal').modal('show');
                };
                /**
                 * Save read only state to database and update current view.
                 */
                scope.saveReadonly = function () {
                    var includeAllChildren = scope.includeAllChildren ?
                        'True' : 'False';
                    scope.treeLoaded = 1;
                    if (scope.readonlyPermission == 'r') {
                        scope.astro.makeReadOnly(scope.selected._id, includeAllChildren).then(function () {
                            scope.selected.makeReadOnly(scope.includeAllChildren);
                            scope.treeLoaded = 2;
                            scope.$apply();
                            // Apply read only state to input screen.
                            scope.triggerEmit("ApplyChangeReadOnly");
                        })["catch"](function (err) {
                            console.log(err);
                            scope.treeLoaded = 2;
                        });
                    }
                    else {
                        scope.astro.makeEditable(scope.selected._id, includeAllChildren).then(function () {
                            scope.selected.makeEditable(scope.includeAllChildren);
                            scope.treeLoaded = 2;
                            scope.$apply();
                            scope.triggerEmit("ApplyChangeReadOnly");
                        })["catch"](function (err) {
                            scope.treeLoaded = 2;
                            console.log(err);
                        });
                    }
                };
                /**
                 * Delete a node. Need to add support for root delete.
                 * When root node is deleted, should display blank panel,
                 * and reload portfolio menu.
                 */
                scope.deleteNode = function () {
                    var portfolioTerm = scope.terminology ? scope.terminology.portfolio : 'portfolio';
                    bootbox.dialog({
                        message: "You are about to delete the node <b> " + scope.selected.name + " </b> from the " + portfolioTerm + ". Are you sure?",
                        title: "Confirm Deletion",
                        buttons: {
                            confirm: {
                                label: "Delete",
                                className: "btn-danger",
                                callback: function () {
                                    scope.actionType = "delete";
                                    scope.onDeleteNode(scope.selected._id);
                                }
                            },
                            cancel: {
                                label: "Cancel",
                                className: "btn-primary"
                            }
                        }
                    });
                };
                scope.cleanPortfolioConfigForRootNode = function (selectedNode) {
                    if (!selectedNode['parent'] && 'PortfolioConfig' in localStorage) {
                        try {
                            var portfolioConfig = JSON.parse(localStorage.PortfolioConfig);
                            delete portfolioConfig[selectedNode.name];
                            localStorage.PortfolioConfig = JSON.stringify(portfolioConfig);
                        }
                        catch (syntaxError) {
                            console.log(syntaxError.message);
                        }
                    }
                };
                // =====================================================
                // Here comes the API interaction part.
                // =====================================================
                // A separate class may be a better idea on this, but due
                // to heavy interaction with scope, I make them stick
                // together in the same place.      -- Fan
                // =====================================================
                /**
                 * Add a new node to tree. Currently cannot handle root node.
                 *
                 * @param {json} addNodeDetails
                 */
                scope.onAddNode = function (addNodeDetails) {
                    var parentNodeId = addNodeDetails.parentNodeId, newNodeName = addNodeDetails.newNodeName, templateName = addNodeDetails.templateName, platformOrLeaf = addNodeDetails.platformOrLeaf, parentTags = addNodeDetails.parentTags, newNodeTags = addNodeDetails.newNodeTags;
                    scope.treeLoaded = 1;
                    newNodeName = newNodeName.trim();
                    var defaultDropdownTags = (scope.treeObj.dropdownCategoryConfig || [])
                        .filter(function (c) { return c.template === templateName; })
                        .map(function (c) { return (c.key + ':' + encodeURIComponent(btoa(c.defaultVal)) + ':' + encodeURIComponent(btoa(c.display))); });
                    scope.astro.createNode(parentNodeId, newNodeName, templateName, platformOrLeaf, parentTags, newNodeTags, defaultDropdownTags).then(function (returnValue) {
                        // Update front end.
                        if (returnValue.status === 0) {
                            scope.treeObj.createChildNode(parentNodeId, returnValue.nodeID, newNodeName, platformOrLeaf.toLowerCase() === "platform", templateName.indexOf(",") < 0 ?
                                [templateName] : templateName.split(","), returnValue.nodePath ? returnValue.nodePath : [], newNodeTags, defaultDropdownTags);
                            scope.onSelectNode({ nodeID: parentNodeId });
                            scope.$emit('workbench:last_updated', { nodeID: returnValue.nodeID });
                            var needRefresh = false;
                            if (scope.filterLogic && scope.filterLogic !== "") {
                                var filterLogic = filter_logic_1.createFilterLogic(scope.filterLogic);
                                var filterList = tree_filter_1.parseSimpleFilterFromString(filterLogic) || [];
                                for (var i = 0; i < filterList.length; i++) {
                                    if (newNodeTags.indexOf(filterList[i].name) == -1) {
                                        scope.$emit('workbench:back', { reload: true });
                                        break;
                                    }
                                }
                            }
                            else if (scope.defaultTreeViewFilters && "filterLogic" in scope.defaultTreeViewFilters && scope.defaultTreeViewFilters['filterLogic'] !== "") {
                                var filterLogic = filter_logic_1.createFilterLogic(scope.defaultTreeViewFilters['filterLogic']);
                                var filterList = tree_filter_1.parseSimpleFilterFromString(filterLogic) || [];
                                for (var i = 0; i < filterList.length; i++) {
                                    if (newNodeTags.indexOf(filterList[i].name) == -1) {
                                        scope.$emit('workbench:back', { reload: true });
                                        break;
                                    }
                                }
                            }
                            if (scope.excludedFilterTags &&
                                scope.excludedFilterTags.length > 0) {
                                scope.$emit('workbench:back', { reload: true });
                            }
                            else if ('excludedTags' in scope.defaultTreeViewFilters &&
                                scope.defaultTreeViewFilters['excludedTags'].length > 0) {
                                scope.$emit('workbench:back', { reload: true });
                            }
                        }
                        scope.treeLoaded = 2;
                        scope.$apply();
                        showAlert('success', 'Success!', 'Node is created successfully.');
                    })["catch"](function (err) {
                        scope.treeLoaded = 2;
                        scope.showAlert({
                            "type": "danger",
                            "title": "Server Error " + err.status,
                            "message": "Failed to create a new node. " + err.message
                        });
                    });
                };
                /**
                 * Edit a node, change its name and templates. Edit template
                 * part is not implemented yet. Will add it soon.
                 *
                 * @param {json} editNodeDetails
                 *
                 */
                scope.onEditNode = function (editNodeDetails) {
                    var nodeId = editNodeDetails.nodeId, newNodeName = editNodeDetails.newNodeName, templateName = editNodeDetails.templateName, children = editNodeDetails.children, saveTags = editNodeDetails.saveTags;
                    scope.treeLoaded = 1;
                    newNodeName = newNodeName.trim();
                    // Call api.
                    // If api returns a new tree object, use this obj directly.
                    // If api returns True/False, handle the tree in front side.
                    scope.astro.editNode(nodeId, newNodeName, templateName, children, saveTags).then(function () {
                        // Update front end.
                        if (!scope.treeObj.editNode(nodeId, newNodeName, children, saveTags)) {
                            showAlert('danger', 'Duplicate Node Name', 'Cannot have duplicate name on same level.');
                        }
                        else {
                            scope.$emit('workbench:last_updated', { nodeID: nodeId });
                            if (scope.treeObj.isRoot(nodeId)) {
                                shareLink.setValue('portfolio', newNodeName);
                                scope.$emit('workbench:emit', {
                                    command: 'RenamePortfolio'
                                });
                            }
                            showAlert('success', 'Success!', 'Edited successfully.');
                        }
                        scope.treeObj.updateTags(saveTags);
                        scope.treeLoaded = 2;
                        scope.$apply();
                    })["catch"](function (err) {
                        scope.treeLoaded = 2;
                        showAlert('danger', 'Server Error ' + err.status, err.message);
                    });
                };
                function updateBrowserTreeData(nodeId, selectedNode, isRoot, deletionSuccess) {
                    if (isRoot === void 0) { isRoot = false; }
                    if (deletionSuccess === void 0) { deletionSuccess = true; }
                    var saveTags = project_category_assignment_logic_1.generateTagsData(scope.selected); //Tags data for the deleted node to be passed up is empty.
                    scope.treeObj.updateTags(saveTags);
                    scope.treeObj.deleteNode(nodeId);
                    if (isRoot && deletionSuccess) {
                        scope.triggerEmit("RefreshPortfolios");
                        shareLink.clearValue("portfolio");
                    }
                    else if (scope.selected.isDataValid === false) {
                        scope.treeObj.updateLeafParents();
                    }
                    shareLink.clearValue("treenode");
                    shareLink.clearValue("menu");
                    shareLink.clearValue("options");
                    scope.cleanPortfolioConfigForRootNode(selectedNode);
                    scope.onSelectNode({ nodeID: undefined });
                }
                /**
                 * Delete a node by its id.
                 *
                 * @param {string} nodeId Node id, not display name.
                 */
                scope.onDeleteNode = function (nodeId) {
                    scope.treeLoaded = 1;
                    var selectedNode = scope.selected;
                    if (!(scope.deletionAttempt && scope.deletionAttempt > 1)) {
                        scope.deletionAttempt = 1;
                    }
                    // Call api.
                    // If api returns a new tree object, use this obj directly.
                    // If api returns True/False, handle the tree in front side.
                    scope.astro.deleteNode(nodeId).then(function (returnValue) {
                        var alertType = 'success';
                        var alertTitle = 'Success!';
                        var msg = 'Node is deleted successfully.';
                        if (returnValue['deletedNodes'].length > 0) {
                            if (returnValue['deletedNodes'].length > 1) {
                                msg = 'Nodes are deleted successfully.';
                            }
                            if (returnValue['undeletedNodes'].length !== 0) {
                                returnValue['deletedNodes'].forEach(function (node) {
                                    updateBrowserTreeData(node['json']['_id'], selectedNode, false, false);
                                });
                            }
                            else {
                                if (scope.treeObj.isRoot(nodeId)) {
                                    msg = scope.terminology.Portfolio + " is deleted successfully.";
                                    updateBrowserTreeData(nodeId, selectedNode, true, true);
                                }
                                updateBrowserTreeData(nodeId, selectedNode, false, true);
                                scope.selected = undefined;
                            }
                        }
                        if (returnValue['undeletedNodes'].length > 0) {
                            returnValue['undeletedNodes'].forEach(function (node) {
                                console.log("Problem in deleting node " + node['name'] + " (" + node['_id'] + ")");
                            });
                            alertType = 'danger';
                            alertTitle = 'Partial Deletion!';
                            msg = 'Some nodes are not deleted.';
                        }
                        showAlert(alertType, alertTitle, msg);
                        scope.treeLoaded = 2;
                        scope.$apply();
                    })["catch"](function (err) {
                        scope.treeLoaded = 2;
                        showAlert('danger', 'Server Error ' + err.status, 'Failed to delete node. ' + err.message);
                    });
                };
                /**
                 * Handle cut, copy and paste. Paste item to parent.
                 *
                 * @param {string} parentId Item will be pasted as a child node
                 *     of this node. It is the id of node.
                 * @param {string} itemId Node with this id will be paste. If
                 *     type is cut, item will be moved to new location instead
                 *     of copy.
                 * @param {string} type Could be 0(CUT)/1(COPY) (all uppercase).
                 */
                scope.onPasteNode = function (parentId, itemId, type, itemParentId, isPortfolio) {
                    if (isPortfolio === void 0) { isPortfolio = false; }
                    scope.treeLoaded = 1;
                    var treeID = scope.treeObj.treeData.name;
                    if (type === "0") {
                        scope.astro.cutPasteNode(parentId, itemId).then(function (returnValue) {
                            // Update front end.
                            if (returnValue.status === 0) {
                                scope.clearSearchKey();
                                if (!isPortfolio) {
                                    //refresh that node only where data is being copied                             
                                    scope.getSubtree({ nodeId: parentId, getNewChildren: true, beingCut: true }).then(function () {
                                        // Refresh the node where data is being cut
                                        scope.getSubtree({ nodeId: itemParentId, getNewChildren: true });
                                    });
                                }
                                else {
                                    //refresh portfolio, as backend operations like cut (might be many nodes) are performed there
                                    scope.$emit('workbench:backAndRecallAPIS', {
                                        reload: true
                                    });
                                }
                                scope.treeLoaded = 2;
                                showAlert('success', 'Success!', 'Cut and pasted successfully.');
                            }
                        })["catch"](function (err) {
                            scope.treeLoaded = 2;
                            showAlert('danger', 'Server Error ' + err.status, 'Failed to paste node. ' + err.message);
                        });
                    }
                    else if (type === "1") {
                        scope.astro.pasteNode(parentId, itemId).then(function (returnValue) {
                            // Update front end.
                            if (returnValue.status === 0) {
                                // Call astro.treeFor to fetch the whole tree, was the old approach
                                // Not handling this in the front end, because
                                // ids, fetchOnDemand and other operations are implemented in the back end.
                                // Thus, only refresh the node where data is being copied, unless pasted on portfolio 
                                scope.clearSearchKey();
                                if (!isPortfolio) {
                                    //refresh that node only where data is being copied 
                                    scope.getSubtree({ nodeId: parentId, getNewChildren: true });
                                }
                                else {
                                    //refresh portfolio, as backend operations like copy (might be many nodes) are performed there
                                    scope.$emit('workbench:backAndRecallAPIS', {
                                        reload: true
                                    });
                                }
                                scope.treeLoaded = 2;
                                showAlert('success', 'Success!', 'Copy and pasted successfully.');
                            }
                        })["catch"](function (err) {
                            scope.treeLoaded = 2;
                            showAlert('danger', 'Server Error ' + err.status, 'Failed to paste node. ' + err.message);
                        });
                    }
                };
                /**
                 * Load all available (not manually disabled) templates for
                 * selected node. (Server find tree from node then get info
                 * by tree.)
                 *
                 * @param nodeID {string} Find templates for this id.
                 */
                scope.loadTemplate = function (nodeID) {
                    scope.astro.templatesFor(nodeID).then(function (returnValue) {
                        scope.treeObj.setTemplate(returnValue.templates);
                        scope.$apply();
                    })["catch"](function (err) {
                        scope.showAlert({
                            "type": "danger",
                            "title": "Server Error " + err.status,
                            "message": "Cannot load template information. " + err.message
                        });
                    });
                };
                /**
                 * Get detailed information of a node. Including is node a
                 * platform and node templates (commands).
                 *
                 * @param nodeID {string} Find info for this id.
                 */
                scope.getNodeInfo = function (nodeID) {
                    scope.astro.nodeBy(nodeID).then(function (returnValue) {
                        if (returnValue.commands &&
                            returnValue.commands.length > 0) {
                            if (returnValue.commands[0].indexOf(",") > -1) {
                                scope.selectedTemplates =
                                    returnValue.commands[0].split(",");
                            }
                            else {
                                scope.selectedTemplates = returnValue.commands;
                            }
                            scope.$apply();
                        }
                    })["catch"](function (err) {
                        scope.showAlert({
                            "type": "danger",
                            "title": "Server Error " + err.status,
                            "message": "Failed to load node information. " + err.message
                        });
                    });
                };
                // =====================================================
                // Emit some command to workbench
                // =====================================================
                /**
                 * Send a command to workbench. Basically for management.
                 *
                 * @param command
                 * @param categoryName
                 */
                scope.triggerEmit = function (command, categoryName) {
                    if (categoryName === void 0) { categoryName = undefined; }
                    if (command == "PortfolioConfiguration") {
                        scope.$emit('workbench:emit', {
                            command: command,
                            saveGlobally: true,
                            showInputConfig: true
                        });
                    }
                    else if (command == "DisplayCategoryAssignment") {
                        scope.$emit('workbench:emit', {
                            command: command,
                            categoryName: categoryName
                        });
                    }
                    else {
                        scope.$emit('workbench:emit', {
                            command: command
                        });
                    }
                };
                scope.$watch('astro.protocols.credentials.isAdmin', function (newVal) {
                    scope.userIsSysAdmin = newVal;
                });
                scope.$watch('treeObj', function (newVal) {
                    if (newVal && newVal.treeData) {
                        scope.astro.getUserPrivilege(newVal.treeData._id).then(function (res) {
                            scope.userIsPortfolioAdmin = res == 3;
                            scope.$apply();
                        })["catch"](function (err) {
                            console.error(err);
                        });
                    }
                });
                scope.compareExcludedFilterTags = function (current, latest) {
                    if (current && latest) {
                        if (current.length !== latest.length) {
                            return true;
                        }
                        else {
                            current.sort();
                            latest.sort();
                            return JSON.stringify(current) !== JSON.stringify(latest);
                        }
                    }
                };
                scope.applyFilters = function (filterLogic, excludedFilterTags, forceApply) {
                    if (excludedFilterTags === void 0) { excludedFilterTags = []; }
                    if (forceApply === void 0) { forceApply = false; }
                    scope.filterLogic = filterLogic;
                    scope.excludedFilterTags = excludedFilterTags;
                    if (scope.treeObj.currentFilterLogic !== filterLogic ||
                        scope.compareExcludedFilterTags(scope.treeObj.currentExcludedFilterTags, excludedFilterTags) ||
                        forceApply) {
                        // scope.treeObj.filterTree(filterLogic);
                        scope.treeObj.filterTreeSubnodes(filterLogic);
                        // scope.treeObj.excludeNodeBy(excludedFilterTags);
                        scope.treeObj.excludeNodeBySubnodes(excludedFilterTags);
                        shareLink.setTreeFilters(filterLogic);
                        shareLink.setTreeExcludeFilters(excludedFilterTags);
                        if (scope.selected && scope.selected.isVisible()) {
                            scope.onSelectNode({ nodeID: scope.selected._id });
                        }
                        else {
                            shareLink.clearValue("treenode");
                            shareLink.clearValue("menu");
                            shareLink.clearValue("options");
                            scope.onSelectNode({ nodeID: null });
                        }
                    }
                };
                // function reloadTree(filterLogic, excludedFilterTags) {
                //     scope.treeLoaded = 1;
                //     let treeID = scope.treeObj.treeName;
                //     scope.astro.treeFor(treeID).then(function (tree) {
                //         scope.treeObj.reloadTree(
                //             new treeMakerModule.TreeMaker(tree, treeID, scope.showTreeColors).jsonTree);
                //
                //         scope.applyFilters(filterLogic, excludedFilterTags, true);
                //
                //         $timeout(() => {
                //             $('.lastUpdatedTooltip').popover({
                //                 placement: 'right',
                //                 trigger: 'hover'
                //             }).on('mouseleave', function () {
                //                 let _this = this;
                //                 if (!$('.popover:hover').length) {
                //                     $(_this).popover('hide');
                //                     scope.$apply();
                //                 }
                //             });
                //         }, 500);
                //         scope.treeLoaded = 2;
                //         scope.$apply();
                //     }).catch(function (err) {
                //         scope.showAlert({
                //             "type": "danger",
                //             "title": "Server Error " + err.status,
                //             "message": "Cannot load tree data. " + err.message
                //         });
                //     });
                // }
                scope.reloadTreeAndApplyFilter = function (showTreeColors, filterLogic, excludedFilterTags) {
                    scope.filterLogic = filterLogic || null;
                    scope.excludedFilterTags = excludedFilterTags || [];
                    if (scope.showTreeColors != showTreeColors) {
                        scope.showTreeColors = showTreeColors;
                        scope.$emit('workbench:showTreeColors', { showTreeColors: showTreeColors });
                        shareLink.setTreeFilters(filterLogic);
                        shareLink.setTreeExcludeFilters(excludedFilterTags);
                        scope.$emit('workbench:back', {
                            reload: true,
                            currentTreeColors: scope.showTreeColors
                        });
                    }
                    else if (scope.treeObj.currentFilterLogic != filterLogic ||
                        scope.compareExcludedFilterTags(scope.treeObj.currentExcludedFilterTags, excludedFilterTags)) {
                        shareLink.setTreeFilters(filterLogic);
                        shareLink.setTreeExcludeFilters(excludedFilterTags);
                        scope.$emit('workbench:back', {
                            reload: true
                        });
                    }
                    // Force digest cycle to update UI
                    // $timeout(() => {
                    //     if (scope.selected && scope.selected.isVisible()) {
                    //         scope.onSelectNode({nodeID: scope.selected._id});
                    //     } else {
                    //         shareLink.clearValue("treenode");
                    //         shareLink.clearValue("menu");
                    //         shareLink.clearValue("options");
                    //         scope.onSelectNode({nodeID: null});
                    //     }
                    // });
                };
                scope.saveDefaultFilters = function (showTreeColors, filterLogic, excludedFilterTags) {
                    scope.defaultTreeViewFilters = { 'filterLogic': filterLogic, 'excludedTags': excludedFilterTags };
                    scope.$emit('workbench:loading', { 'load': true });
                    scope.astro.setDefaultTreeViewFilters(scope.treeObj.treeName, { 'filterLogic': filterLogic, 'excludedTags': excludedFilterTags }).then(function (result) {
                        if (result) {
                            scope.treeObj.setDefaultTreeViewFilters(filterLogic);
                            scope.treeObj.filterTreeSubnodes(filterLogic);
                            scope.treeObj.setDefaultTreeViewExcludeFilters(excludedFilterTags);
                            scope.treeObj.excludeNodeBySubnodes(excludedFilterTags);
                            shareLink.setTreeFilters(filterLogic);
                            shareLink.setTreeExcludeFilters(excludedFilterTags);
                            shareLink.setDefaultTreeFilters(filterLogic);
                            shareLink.setDefaultTreeExcludeFilters(excludedFilterTags);
                            showAlert('success', 'Success!', 'Set default filters successfully.');
                        }
                        else {
                            showAlert('danger', 'Error!', 'Failed to set default filters.');
                        }
                        scope.$emit('workbench:loading', { 'load': false });
                    })["catch"](function (err) {
                        showAlert('danger', 'Error!', 'Failed to set default filters! See console for more details');
                        console.error(err);
                    });
                    scope.filterLogic = filterLogic;
                    scope.excludedFilterTags = excludedFilterTags;
                    // scope.saveDefaultTreeColors(showTreeColors);
                };
                scope.getNodeColor = function (hasChildren, colorData) {
                    return !hasChildren && colorData && 'color' in colorData ?
                        'color: ' + colorData['color'] : 'color: black';
                };
                // scope.saveDefaultTreeColors = (showTreeColors) => {
                //     const showTreeColors = showTreeColors;
                //     scope.astro.setDefaultTreeColors(
                //         scope.treeObj.treeName, showTreeColors).then((result) => {
                //         if (result) {
                //             scope.reloadTreeAndApplyFilter(showTreeColors, scope.filterLogic, scope.excludedFilterTags);
                //             // showAlert('success', 'Success!', 'Set default colors successfully.');
                //         } else {
                //             showAlert('danger', 'Error!', 'Failed to set default colors.');
                //         }
                //     }).catch((err) => {
                //         showAlert('danger', 'Error!', 'Failed to set default colors! See console for more details');
                //         console.error(err);
                //     });
                // };
                scope.showRecycleBin = function () {
                    scope.$broadcast('recycle-bin:init');
                };
                scope.postRecover = function () {
                    scope.$emit('workbench:back', {
                        reload: true,
                        currentTreeColors: scope.showTreeColors
                    });
                };
                scope.closeRecycleBin = function () {
                    $('#recycleBinModal').modal('hide');
                };
            }
        };
    }]);
angular.module("smartorg.r6.navs.tree").directive('ngRightClick', function ($parse) {
    return function (scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function (event) {
            scope.$apply(function () {
                event.preventDefault();
                fn(scope, { $event: event });
            });
        });
    };
});
angular.module("smartorg.r6.navs.tree").directive('scrollable', [function () {
        return {
            link: function (scope, element, attrs) {
                element.bind('scroll', function () {
                    $("#contextMenu").css({ 'display': 'none' });
                });
            }
        };
    }]);
//# sourceMappingURL=tree-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/plumbing/tree-directive.js